export const StatusEnum = {
  ACTIVE: 1,
  INACTIVE: 0,
  DEALLOCATED: 2,
};
